/*jshint esversion: 6 */

import get from 'lodash/get';

export const isVerified = (auth) => {
    return get(auth, 'uid');
};
